import { render, staticRenderFns } from "./BlockchainAddress.vue?vue&type=template&id=772d5019&scoped=true&"
import script from "./BlockchainAddress.vue?vue&type=script&lang=js&"
export * from "./BlockchainAddress.vue?vue&type=script&lang=js&"
import style0 from "./BlockchainAddress.vue?vue&type=style&index=0&id=772d5019&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772d5019",
  null
  
)

export default component.exports